module.exports = __webpack_public_path__ + "media/images/escudo1-5e4e7100273551e8258c7e3cd2b24d57.png";